import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import safeSessionStorage from '../services/sessionStorage';
import { AuthState } from '../types/StoreTypes';

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      isAuthenticated: false,

      setToken: (token: string) => {
        safeSessionStorage.setItem('accessToken', token);
        set({
          accessToken: token,
          isAuthenticated: true,
        });
      },

      clearToken: () => {
        safeSessionStorage.removeItem('accessToken');
        set({
          accessToken: null,
          isAuthenticated: false,
        });
      },

      initializeAuth: () => {
        const token = safeSessionStorage.getItem('accessToken');
        set({
          accessToken: token,
          isAuthenticated: !!token,
        });
      },
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        accessToken: state.accessToken,
        isAuthenticated: state.isAuthenticated,
      }),
    },
  ),
);
